import { useTranslation } from "react-i18next";
import FormSection from "../../../../common/components/functional/formSection/FormSection";
import { ContentKey } from "../../TalentDetails";
import { TalentContentKey } from "../../constants";
import TalentCertificatesTable from "../TalentCertificatesTable";

type Props = {
  handleOpenEditModal: (content: ContentKey) => void;
};

const TalentWorkPermits = ({ handleOpenEditModal }: Props) => {
  const { t } = useTranslation("talentProfile");

  const headers = [
    { text: t("talentProfile:certificateType") },
    { text: t("talentProfile:valid") },
  ];

  return (
    <FormSection title={t("talentProfile:workPermitsTitle")} margin>
      <TalentCertificatesTable
        handleOpenEditModal={handleOpenEditModal}
        headers={headers}
        contentKey={TalentContentKey.WorkPermits}
        addButtonLabel={t("talentProfile:addWorkPermit")}
      />
    </FormSection>
  );
};

export default TalentWorkPermits;
